import { forwardRef, Ref } from 'react';
import { addLocale } from 'primereact/api';
import { Calendar as CalendarPR, CalendarProps, CalendarSelectionMode } from 'primereact/calendar';
import { CalendarIcon, ChevronIcon } from './icons';

const ATOMIC_CALENDAR_LOCALE = 'atomic-calendar';

addLocale(ATOMIC_CALENDAR_LOCALE, {
  dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
});

export type CalendarRef = CalendarPR;

export const Calendar = forwardRef<CalendarPR, CalendarProps<CalendarSelectionMode>>((props, ref?: Ref<CalendarPR>) => {
  const locale = props.locale === undefined || props.locale === 'en' ? ATOMIC_CALENDAR_LOCALE : props.locale;

  return (
    <CalendarPR
      ref={ref}
      {...props}
      locale={locale}
      showOnFocus={props.showOnFocus ?? false}
      showIcon={props.showIcon ?? true}
      icon={props.icon || <CalendarIcon />}
      prevIcon={
        props.prevIcon || (
          <div className="text-black">
            <ChevronIcon className="rotate-90 [&>path]:stroke-current" width={11} height={7} />
          </div>
        )
      }
      nextIcon={
        props.nextIcon || (
          <div className="text-black">
            <ChevronIcon className="rotate-270 [&>path]:stroke-current" width={11} height={7} />
          </div>
        )
      }
    />
  );
});

export type { CalendarProps, CalendarSelectionMode };
